<template>
  <div class="animated fadeIn">
    <div id="snackbar" style="color:red;"></div>
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong> Add Display </strong>
            <small>Form</small>
          </div>
          <b-form ref="popupform" v-on:submit.prevent.self="submitFinalData">
            <b-row>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    v-model="pageForm.cinema_selected"
                    :options="CinemasList"
                    track-by="cine_id"
                    label="cine_name"
                    :multiple="false"
                    placeholder="Select Cinema"
                  ></multiselect>
                </b-form-group>
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-form-input
                      type="text"
                      v-model="pageForm.display_name"
                      id="poptitle"
                      placeholder="Display  Name"
                    ></b-form-input>
                    <label>Display Name</label>
                  </div>
                </b-form-group>
              </div>
              <!--Black || Red Theme Dropdown-->
              <!-- <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    :options="theme_array"
                    :multiple="false"
                    placeholder="Select Theme"
                    v-model="pageForm.theme_type"
                    :allowEmpty="false"
                  ></multiselect>
                </b-form-group>
              </div> -->

              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    :options="orientationArray"
                    :multiple="false"
                    track-by="o_type_id"
                    label="o_type_name"
                    placeholder="Select Orientation"
                    @select="onChangeOrientation"
                    v-model="pageForm.orientation_type"
                  ></multiselect>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <multiselect
                    :options="typeArray"
                    :multiple="true"
                    track-by="type_id"
                    label="type_name"
                    placeholder="Select Type"
                    v-model="pageForm.type_selected"
                  ></multiselect>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-form-input
                      type="text"
                      v-model="pageForm.display_width"
                      id="poptitle"
                      placeholder="Display Width"
                    ></b-form-input>
                    <label>Display Width</label>
                  </div>
                </b-form-group>
              </div>
              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-form-input
                      type="text"
                      v-model="pageForm.display_height"
                      id="poptitle"
                      placeholder="Display Height"
                    ></b-form-input>
                    <label>Display Height</label>
                  </div>
                </b-form-group>
              </div>

              <div class="col-lg-4 col-xl-3 align-self-center mb-4">
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-form-input
                      type="number"
                      v-model="pageForm.sliderInSec"
                      placeholder="In Seconds"
                    ></b-form-input>
                    <label>Slide Timer (In Seconds)</label>
                  </div>
                </b-form-group>
              </div>

              <div class="col-lg-8 col-xl-6 align-self-center mb-4">
                <b-form-group>
                  <div class="input-material mt-2">
                    <b-textarea v-model="pageForm.description"></b-textarea>
                    <label>Description</label>
                  </div>
                </b-form-group>
              </div>
              <!-- 
              <div class="input-material-textarea">
                <div class="col-lg-12 align-self-center mb-4">
                  <div class="descriptionSection font-weight-bold fs-14 mb-3">
                    Description
                  </div>
                  <div class="" >
                    <vue-editor
                      v-model="pageForm.description"
                      name="page"
                      id="page"
                    ></vue-editor>
                  </div>
                </div>
              </div> -->
            </b-row>

            <h5 class="my-3">Play Your Own Image/Video :</h5>

            <div v-for="(item, index) in Url" :key="index" class="row">
              <div class="col-3 mb-4 pr-0">
                <label class="material-file-upload">
                  <!-- v-on:change="onFileUpload($event,PosterItem,PosterIndex,MovieContentIndex)" -->
                  <input
                    type="file"
                    accept="video/*,image/*"
                    v-on:change="setImage($event, index)"
                    name="image"
                    :id="'image' + index"
                  />
                  <div
                    class="label"
                    v-bind:class="{
                      'shift-up':
                        item.selected_url && item.selected_url.length > 0
                    }"
                  >
                    <div class="text-truncate">Upload Image | Video</div>
                  </div>
                  <div class="uploaded-file-name">
                    <div class="text-truncate pt-2">
                      {{ item.selected_url }}
                    </div>
                  </div>
                </label>
                <div v-if="item.uploadPercentage != 0">
                  <div class="row">
                    <div class="col-10 pl-4 pt-2 pr-1">
                      <!-- <progress max="100" class="w-100" :class="item.uploadPercentage == 100 ? 'bg-success': ''" :value="item.uploadPercentage"></progress> -->
                      <div class="progress" style="height: 0.5rem">
                        <div
                          class="progress-bar progress-bar-striped"
                          :class="
                            item.uploadPercentage == 100 ? 'bg-success' : ''
                          "
                          role="progressbar"
                          v-bind:style="{ width: item.uploadPercentage + '%' }"
                          :aria-valuenow="item.uploadPercentage"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div class="col-2 p-0" style="font-size: 13px">
                      {{ item.uploadPercentage + "%" }}
                    </div>
                  </div>
                </div>
              </div>
              <p class="error_message">
                <span v-if="item.selected_url && item.selected_url.length == 0"
                  >Please Select an Image.</span
                >
              </p>
              <div class="col-1 mb-4">
                <img
                  v-if="
                    item.selected_url.length > 0 &&
                      item.selected_type == 'image'
                  "
                  :src="_GetImagePath(item.selected_url)"
                  @click="
                    openImageModal(
                      'Image',
                      item.selected_url,
                      item.selected_type
                    )
                  "
                  height="38"
                  width="38"
                  class="rounded c-pointer"
                />
                <img
                  v-else-if="
                    item.selected_url.length > 0 &&
                      item.selected_type == 'video'
                  "
                  src="@/assets/img/icons/play.svg"
                  @click="
                    openImageModal(
                      'Video',
                      item.selected_url,
                      item.selected_type
                    )
                  "
                  height="38"
                  width="38"
                  class="rounded c-pointer"
                />
                <img
                  v-else
                  src="@/assets/img/icons/empty-image.svg"
                  height="35"
                  width="35"
                  class="rounded"
                />
              </div>
              <div class="col-3 mb-4 pl-1">
                <button
                  v-if="index == 0"
                  @click.prevent.stop="addGeneric()"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/plus.svg"
                    height="35"
                    width="35"
                  />
                </button>
                <button
                  v-else
                  @click.prevent.stop="removeGeneric(index)"
                  class="btn-transparent"
                >
                  <img
                    src="@/assets/img/icons/minus.svg"
                    height="35"
                    width="35"
                  />
                </button>
              </div>
            </div>

            <b-row class="m-2">
              <b-col sm="4">
                <b-button
                  type="submit"
                  size="sm"
                  variant="primary"
                  @click="onFinalSubmit"
                >
                  <i class="fa fa-dot-circle-o"></i>
                  {{ !pageForm.display_id ? "Add" : "Save" }}
                </b-button>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <div>
      <b-modal
        id="modalPopover"
        title="See Images"
        ref="showImages"
        @ok="onOkay"
      >
        <div>
          <draggable
            v-model="bannerImg"
            ref="bannerImg"
            class="d-flex justify-content-center flex-wrap"
            group="image"
            @start="drag = true"
            @end="drag = false"
          >
            <div
              sm="4"
              v-for="(item, index) in bannerImg"
              :key="index"
              class="m-2"
            >
              <img :src="BASE_URL + item" style="width:100px;height:100px" />
              <div class="m-2">
                <button class="btn-blue" @click="removeImagesFill(index)">
                  Remove
                </button>
              </div>
            </div>
          </draggable>
        </div>
      </b-modal>
    </div>

    <b-modal
      ref="preview-modal"
      id="selected-image-preview-modal"
      size="lg"
      hide-header
      hide-footer
    >
      <label class="h4 mt-2 mb-4 text-center">{{ tempModalImageName }}</label>
      <button
        class="btn-modal-close"
        @click="$bvModal.hide('selected-image-preview-modal')"
      >
        &times;
      </button>
      <img
        :src="_GetImagePath(tempModalImagePath)"
        v-if="tempContentType == 'image'"
        class="img-fluid"
      />
      <video
        autoplay
        :src="_GetImagePath(tempModalImagePath)"
        v-if="tempContentType == 'video'"
        class="img-fluid"
      />
    </b-modal>

    <b-modal
      id="imagecropper"
      title="Crop Image"
      hide-footer
      no-close-on-backdrop
    >
      <button
        class="btn-clearDate text-right"
        v-on:click="hideCropperModal('imagecropper')"
      >
        ✖
      </button>

      <label class="h4 mt-2 mb-4 text-center">Crop Image</label>
      <vue-cropper
        ref="cropper"
        :src="imgSrc"
        :viewMode="1"
        :cropBoxResizable="true"
        dragMode="none"
        alt="Source Image"
        preview=".preview"
      ></vue-cropper>
      <br />
      <button class="btn-blue" @click.prevent.stop="cropImage">Save</button>
    </b-modal>
  </div>
</template>

<script>
import draggable from "vuedraggable";
import MasterService from "@/services/MasterService";
import ExhibitorService from "@/services/ExhibitorService";
import { VueEditor } from "vue2-editor";
import VueCropper from "vue-cropperjs";
import signageServices from "@/services/signageService";

import "cropperjs/dist/cropper.css";

export default {
  name: "AddPopupPages",
  data() {
    return {
      editMode: false,
      bannerType: "",
      bannerIndex: "",
      BaseURL: "",
      Ratings: [],
      isEdit: true,
      staticNames: {
        name: "Add"
      },
      modalObject: {
        title: "fdsfds"
      },
      cinemaListArray: [],
      popupType: 0,
      countryOptions: [],
      LanguageArray: [],
      typeArray: [
        { type_id: 1, type_name: "Schedule" },
        { type_id: 2, type_name: "Offer" },
        { type_id: 3, type_name: "Upcoming Movies" }
      ],
      orientationArray: [
        { o_type_id: 1, o_type_name: "Horizontal" },
        { o_type_id: 2, o_type_name: "Vertical" }
      ],
      pagesList: {
        pp_id: "",
        mpm_id: "",
        main_name: "",
        country_id: "",
        description: "",
        language: "",
        popup_rating_url: "",
        isActive: false,
        popup_rating_title: "",
        banner: "",
        status: "Y",
        ratingType: ""
      },
      error: {
        mpm_id_error_msg: false,
        main_name_error_msg: false,
        country_id_error_msg: false,
        description_error_msg: false,
        language_error_msg: false,
        popup_rating_url_error_msg: false,
        isActive_error_msg: false,
        popup_rating_title_error_msg: false,
        banner_error_msg: false,
        status_error_msg: false,
        ratingType_error_msg: false
      },
      imageSize: {
        width: 125,
        height: 125
      },

      imagesVmodel: "",
      imagesIndex: "",
      bannerImg: [],
      CinemasList: [],
      CinemasListCopy: [],
      pageForm: {
        cinema_selected: "",
        display_id: "",
        display_name: "",
        type_selected: "",
        description: "",
        orientation_type: "",
        sliderInSec: 30,
        display_height: 0,
        display_width: 0,
        theme_type: "Red Theme"
      },
      Url: [
        {
          selected_url: "",
          selected_type: "",
          uploadPercentage: 0
        }
      ],
      theme_array: ["Red Theme", "Black Theme"],
      file: "",
      imgSrc: "",
      cropImg: "",
      filename: "",
      indexofthubmnail: "",
      tempModalImageName: null,
      tempModalImagePath: null,
      tempContentType: ""
    };
  },
  components: {
    VueEditor,
    draggable,
    VueCropper
  },
  computed: {},
  watch: {},
  async beforeMount() {
    if (true) {
      this.isRoleID = false;
    }

    // this.getAllActiveScreens();
    this.getAllActiveCinemas();
  },
  mounted: function() {},
  methods: {
    onChangeOrientation(event) {
      if (event.o_type_name == "Horizontal") {
        this.pageForm.display_width = 1920;
        this.pageForm.display_height = 1080;
      } else {
        this.pageForm.display_height = 1920;
        this.pageForm.display_width = 1080;
      }
    },
    onFinalSubmit() {
      if (!this.pageForm.cinema_selected) {
        this.$toasted.show("Please Select Cinema");
        return false;
      }

      if (!this.pageForm.display_name) {
        this.$toasted.show("Please Enter Display Name");
        return false;
      }

      if (!this.pageForm.orientation_type) {
        this.$toasted.show("Please Select Orientation");
        return false;
      }

      if (!this.pageForm.type_selected) {
        this.$toasted.show("Please Select Type");
        return false;
      }

      if (!this.pageForm.sliderInSec) {
        this.$toasted.show("Please Select Slider Timer");
        return false;
      }

      if (this.pageForm.sliderInSec < 1) {
        this.$toasted.show("Timer Should be greater than zero");
        return false;
      }

      let filter_image = this.Url.filter(z => {
        return z.selected_url;
      });

      if (this.Url.length != filter_image.length) {
        return this.$toasted.show(
          "Please select all Image/Video in Play Your Own Video"
        );
      }

      let loader = this.$loading.show();
      let payload = {
        ...this.pageForm,
        image_selected: this.Url,
        cinema_id: this.pageForm.cinema_selected.cine_id,
        orientation_type_name: this.pageForm.orientation_type.o_type_name
      };
      console.log(payload);
      signageServices.AddDisplaySignageUrl(payload).then(response => {
        const { data } = response;
        loader.hide();

        if (data && data.status) {
          this.$toasted.show(data.message);
          this.$router.go(-1);
        } else {
          // Show Error message
          this.$toasted.show(data.message);
        }
      });
    },
    cropImage() {
      this.$bvModal.hide("imagecropper");

      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      // this.data = JSON.stringify(this.$refs.cropper.getData(), null, 4);
      var block = this.cropImg.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      this.onThumbnailUpload(blob1, this.filename, this.indexofthubmnail);
    },

    onThumbnailUpload: function(image, filename, index) {
      let loader = this.$loading.show();

      let formData = new FormData();
      formData.append("image", image, filename);
      formData.append("imagePath", "Signage Image");
      let JWT = window.localStorage.getItem("JWT_TOKEN");
      const options = {
        headers: {
          "content-type": "multipart/form-data",
          Authorization: JWT,
          "Access-Control-Allow-Origin": "*"
        },
        onUploadProgress: event => {
          const { loaded, total } = event;
          const percent = Math.floor((loaded / total) * 100);
          this.Url[index].uploadPercentage = percent;
        }
      };
      MasterService.GlobalUploadImage(formData, options)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.Url[index].selected_url = data.path;
            this.imgSrc = "";
            this.$bvModal.hide("imagecropper");
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },

    hideCropperModal: function(modal) {
      this.$bvModal.hide("imagecropper");
    },
    addGeneric: function() {
      this.Url.push({
        selected_url: "",
        selected_type: "",
        uploadPercentage: 0
      });
    },
    removeGeneric: function(index) {
      this.Url.splice(index, 1);
    },
    b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || "";
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(b64Data);
      var byteArrays = [];

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
    openImageModal: function(name, path, type) {
      this.tempModalImagePath = path;
      this.tempModalImageName = name;
      this.tempContentType = type;
      this.$refs["preview-modal"].show();
    },
    //Set Image
    setImage: function(e, index) {
      this.file = e.target.files[0];
      this.filename = e.target.files[0]["name"];
      this.indexofthubmnail = index;

      if (this.file.type.indexOf("image/") !== -1) {
        this.Url[index].selected_type = "image";

        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = event => {
            this.imgSrc = event.target.result;
            this.width = 129;
            this.height = 192;
            // this.$cropper.setAspectRatio(1);
            // rebuild cropperjs with the updated source
            this.$bvModal.show("imagecropper");
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
        }
      } else if (this.file.type.indexOf("video/") !== -1) {
        this.Url[index].selected_type = "video";

        if (typeof FileReader === "function") {
          const reader = new FileReader();
          reader.onload = event => {
            this.imgSrc = event.target.result;

            this.VideoFilter();
            e.target.value = "";
          };
          reader.readAsDataURL(this.file);
        } else {
          // alert("Sorry, FileReader API not supported");
        }
      } else {
        this.$toasted.show("Please select an Image file OR Video File.");
        return;
      }
    },
    VideoFilter() {
      var block = this.imgSrc.split(";");
      // Get the content type of the image
      var contentType = block[0].split(":")[1]; // In this case "image/gif"
      // get the real base64 content of the file
      var realData = block[1].split(",")[1]; // In this case "R0lGODlhPQBEAPeoAJosM...."
      // Convert it to a blob to upload
      var blob1 = this.b64toBlob(realData, contentType);
      this.OnVideoUpload(blob1, this.filename, this.indexofthubmnail);
    },
    OnVideoUpload: function(video, filename, index) {
      this.load;

      let formData = new FormData();
      formData.append("video", video, filename);
      formData.append("videoPath", "Generic Signage");

      const options = {
        headers: {
          "content-type": "multipart/form-data",
          "Access-Control-Allow-Origin": "*"
        },
        onUploadProgress: event => {
          const { loaded, total } = event;
          const percent = Math.floor((loaded / total) * 100);
          this.Url[index].uploadPercentage = percent;
        }
      };

      MasterService.GlobalUploadVideo(formData, options)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.Url[index].selected_url = data.path;
            this.imgSrc = "";
          } else {
            data["message"] && data["message"]["message"]
              ? this.$toasted.show(data.message.message)
              : this.$toasted.show(
                  data.message ||
                    "Sorry! Something went wrong. kindly contact your administrator"
                );
          }
        })
        .catch(this._CatchError)
        .finally(() => {
          console.log("this.uploadpercent", this.uploadPercentage);
        });
    },
    getSignageList(display_id) {
      let loader = this.$loading.show();
      let payload = {
        limit: 10,
        currentPage: 1,
        display_id
      };
      this.SignageDisplayArray = [];
      signageServices
        .getDisplaySignage(payload)
        .then(response => {
          const { data } = response;
          loader.hide();
          if (data.status) {
            if (
              data.Records.hasOwnProperty("data") &&
              data.Records.data.length > 0
            ) {
              let new_data = data.Records.data[0];
              this.pageForm = {
                cinema_selected: this.CinemasList.filter(z => {
                  return z.cine_id == new_data.cinema_id;
                })[0],
                display_id: new_data.display_id,
                display_name: new_data.display_name,
                display_height: new_data.display_height,
                display_width: new_data.display_width,
                type_selected: JSON.parse(new_data.type_array),
                description: new_data.description,
                orientation_type: this.orientationArray.filter(z => {
                  return z.o_type_name == new_data.orientation_type;
                })[0],
                sliderInSec: new_data.slider_timer,
                theme_type: new_data.theme_type
              };
              this.Url = JSON.parse(new_data.extra_image_video_play);
            } else {
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch(error => {});
    },

    getAllActiveCinemas: function() {
      MasterService.GetCinemas()
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.CinemasList = data.Records;
            this.CinemasListCopy = data.Records;

            if (this.$route.params.display_id) {
              this.getSignageList(this.$route.params.display_id);
            }
          } else {
            // Show Error message
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          this.$toasted.show(Error(error));
          console.log("Catch Error on getAllActiveCinemas :", error);
        });
    },

    onOkay() {
      if (this.imagesIndex < 0) {
        this.pagesList[this.bannerType] = this.bannerImg.join(",");
      } else {
        this.pagesList.otherData[this.bannerIndex][
          this.bannerType
        ] = this.bannerImg.join(",");
      }
    },

    getLanguagesList: function() {
      // getCountriesList

      let payload = {
        tableName: "ms_language",
        lang_is_active: "Y"
      };
      return MasterService.GetActiveList(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            //console.log("langres", data.Records);
            this.LanguageArray = data.Records;
          } else {
            //console.log("Error from language", data.message);
          }
        })
        .catch(error => {
          //console.log(error, "from language catch");
        });
    },

    openModal: function(ref) {
      this.$refs[ref].show();
    },
    closeModal: function(ref) {
      this.$refs[ref].hide();
      this.modalObject.title = ""; // "Confirmation";
      this.modalObject.message = ""; // "Please re-check the data before submit";
    },
    // Show Confirmmation Dialog End

    validateData() {
      if (this.pagesList.main_name.pop_id == 1) {
        //Language Validation

        if (!this.pagesList.language) {
          this.error.language_error_msg = true;
          return false;
        } else if (!this.pagesList.language.lang_id) {
          this.error.language_error_msg = true;
          return false;
        } else {
          this.error.language_error_msg = false;
        }

        //Banner Validation

        if (!this.pagesList.banner) {
          console.log("hello");
          this.error.banner_error_msg = true;
          return false;
        } else {
          this.error.banner_error_msg = false;
        }

        //Title Validation

        if (!this.pagesList.popup_rating_title) {
          console.log("hello");
          this.error.popup_rating_title_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_title_error_msg = false;
        }

        //Country Validation

        if (!this.pagesList.country_id.length > 0) {
          this.error.country_id_error_msg = true;
          return false;
        } else {
          this.error.country_id_error_msg = false;
        }

        //Banner URL Validation

        if (!this.pagesList.popup_rating_url.length > 0) {
          this.error.popup_rating_url_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_url_error_msg = false;
        }

        // Verification Done!
        return true;
      } else if (this.pagesList.main_name.pop_id == 2) {
        if (!this.pagesList.language) {
          this.error.language_error_msg = true;
          return false;
        } else if (!this.pagesList.language.lang_id) {
          this.error.language_error_msg = true;
          return false;
        } else {
          this.error.language_error_msg = false;
        }

        //Rating Validation
        console.log(this.pagesList.ratingType);

        if (!this.pagesList.ratingType) {
          this.error.ratingType_error_msg = true;
          return false;
        } else if (!this.pagesList.ratingType.rat_id) {
          this.error.ratingType_error_msg = true;
          return false;
        } else {
          this.error.ratingType_error_msg = false;
        }

        //Banner Validation

        if (!this.pagesList.banner) {
          console.log("hello");
          this.error.banner_error_msg = true;
          return false;
        } else {
          this.error.banner_error_msg = false;
        }

        //Title Validation

        if (!this.pagesList.popup_rating_title) {
          console.log("hello");
          this.error.popup_rating_title_error_msg = true;
          return false;
        } else {
          this.error.popup_rating_title_error_msg = false;
        }

        //Country Validation

        if (!this.pagesList.country_id.length > 0) {
          this.error.country_id_error_msg = true;
          return false;
        } else {
          this.error.country_id_error_msg = false;
        }

        //Description Validation

        if (!this.pagesList.description) {
          console.log("hello");
          this.error.description_error_msg = true;
          return false;
        } else {
          this.error.description_error_msg = false;
        }

        // Verification Done!
        return true;
      } else {
        if (this.pagesList.main_name.pop_id) {
          return false;
        }
      }
    },
    submitFinalData() {
      if (this.validateData()) {
        let loader = this.$loading.show();
        let testArr = [];
        let all_country_ids = Array.isArray(this.pagesList.country_id)
          ? this.pagesList.country_id.map(v => v.country_id).join(",")
          : "";

        const popupData = {
          pp_id: this.editMode ? this.pagesList.pp_id : undefined,
          pp_type_id: this.pagesList.main_name.pop_id
            ? this.pagesList.main_name.pop_id
            : "",
          pp_name: this.pagesList.main_name.pop_name
            ? this.pagesList.main_name.pop_name
            : "",
          pp_lang_id:
            this.pagesList.language && this.pagesList.language.lang_id
              ? this.pagesList.language.lang_id
              : "",
          pp_rating_type: this.pagesList.ratingType.rat_id
            ? this.pagesList.ratingType.rat_id
            : "",
          pp_banner: this.pagesList.banner,
          pp_title: this.pagesList.popup_rating_title,
          pp_country_id: all_country_ids,
          pp_image_url: this.pagesList.popup_rating_url,
          pp_description: this.pagesList.description,
          is_active: this.pagesList.isActive
        };

        testArr.push(popupData);
        let payload = {
          popupPages: testArr
        };
        //console.log(payload);
        ExhibitorService.AddPopup(payload)
          .then(response => {
            const { data } = response;
            if (!this.editMode) {
              this.resetStaticBanner();
            }
            this.$toasted.show(data.message);
          })
          .catch(err => {
            //console.log(err);
          })
          .finally(() => {
            setTimeout(() => loader.hide(), 1000);
          });
      }
    }
  },
  updated() {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/NewSignage/add-signage-display.vue